export default __webpack_public_path__ + "static/media/1.a7a29096.svg";